import { lazy } from 'react';
import { PrivateRoute } from '../../components/PrivateRoute/PrivateRoute';
import { baseUrls } from '../../constants/urls';
const GeneralRequests = lazy(() => import('./pages/GeneralRequests/GeneralRequests'));
const CreateGeneralRequest = lazy(() => import('./pages/CreateGeneralRequest/CreateGeneralRequest'));
const ViewGeneralRequest = lazy(() => import('./pages/ViewGeneralRequest/ViewGeneralRequest'));

const GeneralRequestRoutes = [
  <PrivateRoute path={baseUrls.generalRequests} exact={true} permissions="generalRequestsEnabled" key="generalRequests">
    <GeneralRequests />
  </PrivateRoute>,
  <PrivateRoute path={baseUrls.createGeneralRequest} exact={true} permissions="generalRequestsEnabled" key="createGeneralRequest">
    <CreateGeneralRequest />
  </PrivateRoute>,
  <PrivateRoute path={baseUrls.generalRequest} exact={true} permissions="generalRequestsEnabled" key="viewGeneralRequest">
    <ViewGeneralRequest />
  </PrivateRoute>
];

export default GeneralRequestRoutes;
